import React from 'react';
import './sideMenuComponent.scss';
import MenuListComponent from "../menu-list/menuListComponent";
import BrandingComponent from "../branding/brandingComponent";
import AppVersionComponent from "../../app-version/appVersionComponent";
import {ChevronLeftOutlined, ChevronRightOutlined} from "@mui/icons-material";
import {PRIVACY_POLICY} from "../../../../constants/RoutesConfig";

export interface SideMenuComponentProps {
    sideMenuView: string,
    handleToggleSideMenu: Function
}

const SideMenuComponent = (props: SideMenuComponentProps) => {
    const {sideMenuView, handleToggleSideMenu} = props;

    return (
        <div className="side-menu-bar">
            <BrandingComponent sideMenuView={sideMenuView}/>
            <div className={`menu-wrapper`}>
                <MenuListComponent sideMenuView={sideMenuView}/>
            </div>
            {sideMenuView === "default" &&
                <div className="menu-toggle-wrapper">
                    <div className="menu-toggle-icon" onClick={() => handleToggleSideMenu("compact")}>
                        <ChevronLeftOutlined/>
                    </div>
                </div>
            }
            {
                sideMenuView === "compact" &&
                <div className="menu-toggle-wrapper">
                    <div className="menu-toggle-icon" onClick={() => handleToggleSideMenu("default")}>
                        <ChevronRightOutlined/>
                    </div>
                </div>
            }
            {sideMenuView === "default" && <div className={"privacy-policy-text"} onClick={() => {
                window.open(PRIVACY_POLICY, "_blank")
            }}>Privacy Policy</div>}
            {/*<div className="logout-wrapper">*/}
            {/*    <LogoutComponent sideMenuView={sideMenuView}/>*/}
            {/*</div>*/}
            <div className="version-wrapper">
                <AppVersionComponent sideMenuView={sideMenuView}/>
            </div>
            {/*<div className="brand-powered-by">*/}
            {/*    <div className={"powered-by-text"}>Powered by</div>*/}
            {/*    <div className={`brand-logo ${sideMenuView === "compact" ? "compact" : ""}`}>*/}
            {/*        <img src={ImageConfig.BrandingImage} alt="AdvanzInnovation Labs"/>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>

    )

};

export default SideMenuComponent;
